import AddIcon from '@mui/icons-material/Add';
import AddCircleRoundedIcon from '@mui/icons-material/AddCircleRounded';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Paper from '@mui/material/Paper';
import { businessActions, businessSelectors } from 'app-components/flux/business';
import { useFetchOnce } from 'app-components/hooks/utils';
import AddBusiness from 'components/Dialogs/AddBusiness';
import QButton from 'components/QButton';
import ZeroStateView from 'components/ZeroStateView';
import BusinessCard from 'containers/BusinessCard';
import SettingsHeader from 'containers/Settings/SharedComponents/SettingsHeader';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()(({ spacing }) => ({
  iconSpacing: {
    marginRight: spacing(1),
  },
}));

export default function Businesses() {
  const { classes } = useStyles();
  const [addBusiness, setAddBusiness] = useState(false);
  const [currentBusinessId, setCurrentBusinessId] = useState(null);

  useFetchOnce(businessActions.getBusiness, businessSelectors);
  const businesses = useSelector(businessSelectors.getBusinessList);

  return (
    <Box>
      {addBusiness && <AddBusiness onClose={() => setAddBusiness(false)} setCurrentBusinessId={setCurrentBusinessId} />}
      <SettingsHeader
        title='Businesses'
        primaryItem={
          <div>
            {businesses?.size > 0 ? (
              <QButton id='accounts-add-new-button' variant='contained' onClick={() => setAddBusiness(true)}>
                <AddIcon className={classes.iconSpacing} /> Business
              </QButton>
            ) : null}
          </div>
        }
      />

      {businesses.map((business) => {
        if (business.id === currentBusinessId) {
          return null;
        }
        return <BusinessCard key={`${business.name}-card`} business={business} />;
      })}

      {businesses?.size === 0 && (
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            width: '100%',
            height: '80vh',
          }}
        >
          <Paper
            sx={{
              flex: 1,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              width: '100%',
              height: '100%',
            }}
          >
            <ZeroStateView
              size='large'
              animate={true}
              qIllustration='businessBriefcase'
              title='Add your business'
              description='Enter your business information to easily track your transactions and stay organized for tax season.'
              button={
                <Button variant='contained' startIcon={<AddCircleRoundedIcon />} onClick={() => setAddBusiness(true)}>
                  Business
                </Button>
              }
            />
          </Paper>
        </Box>
        // <Box
        //   display='flex'
        //   alignItems='center'
        //   justifyContent='center'
        //   height='673px'
        //   width='100%'
        //   flexDirection='column'
        //   textAlign='center'
        //   backgroundColor={'background.paper'}
        //   borderRadius='20px'
        // >
        //   <img alt='thumbs-up' src={businessGSFIcon} width={168} height='auto' />
        //   <Typography variant='displayRegular'>Add your business</Typography>
        //   <Typography color='textSecondary' className={classes.zeroStateText}>
        //     Enter your business information to easily track your transactions and stay organized for tax season.
        //   </Typography>
        //   <QButton id='accounts-add-new-button' variant='contained' onClick={() => setAddBusiness(true)}>
        //     <AddIcon className={classes.iconSpacing} /> Business
        //   </QButton>
        // </Box>
      )}
    </Box>
  );
}
